import React, { useEffect, useState } from 'react';
import { Layout } from 'antd';

import ResellerServices from 'services/reseller';

import { DetailReseller } from 'components/detail-reseller';
import { errHandling } from 'utils';
import { get } from 'lodash';
import { useLocation } from 'react-router-dom';

export function DetailStatusReseller() {
  const [value, setValue] = useState({});
  const [loading, setLoading] = useState(false);

  const location = useLocation();
  const urlParams = new URLSearchParams(location.search);
  const id = urlParams.get('id') || '';

  async function getUser() {
    setLoading(true);
    try {
      const { data } = await ResellerServices.getResellerDetail(id);
      const customerDetail = get(data, 'data', []);
      setValue(customerDetail);
    } catch (error) {
      errHandling(error);
    } finally {
      setLoading(false);
    }
  }

  const isAccepted = value.application_status === 'accepted' ? true : false;
  const showDoc = isAccepted ? false : true;

  useEffect(() => {
    if (id) getUser();
    // eslint-disable-next-line
  }, [id]);

  return (
    <Layout className="main-container">
      <div className="content">
        <div className="pageTitle">Detail Reseller Status</div>
        <DetailReseller
          accepted={isAccepted}
          docs={showDoc}
          id={id}
          loading={loading}
          value={value}
        />
      </div>
    </Layout>
  );
}

export default { DetailStatusReseller };
